import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, map } from 'rxjs';
import { ApiConstants } from 'src/app/core/constants/api.constants';
import { TuwaiqConfig } from 'src/app/core/constants/tuwaiq.config';

interface Section {
    id: number;
    name: string;
    sectionCode: string;
}

@Injectable()
export class SectionsService {
    private sectionChange$: Subject<string> = new Subject<string>();
    private statusChange$: Subject<any> = new Subject<any>();

    public constructor(private readonly http: HttpClient) {}

    public getAll(userPath): Observable<Section[]> {
        let parameters = new HttpParams();
        if (userPath !== 'data-management') {
            parameters = parameters.append(TuwaiqConfig.REQUEST_QUERY_PARAMS.SECTION_FOR_IC, true);
        }

        return this.http.get(ApiConstants.All_SECTIONS, { params: parameters }).pipe(map((response: { data: Section[]; meta: any }) => response.data));
    }

    public get sectionChanging(): Observable<string> {
        return this.sectionChange$.asObservable();
    }

    public setSectionChanging(value: string): void {
        this.sectionChange$.next(value);
    }
    public get statusChanging(): Observable<any> {
        return this.statusChange$.asObservable();
    }
    public setStatusChanging(value: string): void {
        this.statusChange$.next(value);
    }
}
